module.exports = __webpack_public_path__ + "img/image1.389dd279.png";